import * as React from 'react';
import { BottomNavigation, BottomNavigationAction, createStyles, withStyles } from '@material-ui/core';
import { Home as HomeIcon } from '@material-ui/icons';

const styles = createStyles({
    root: {
        bottom: 0,
        position: 'absolute',
        width: '100%',
    }
});

const BottomNav = (props: any) => {
    const {classes} = props;
    return (
        <BottomNavigation className={classes.root} >
            <BottomNavigationAction label='Home' icon={<HomeIcon/>}/>
        </BottomNavigation>
    );
};

export default withStyles(styles)(BottomNav);